(function(){

  /* ---------------- Daten ---------------- */

  const questions = [
    {
      text: "Wie startest du in eine neue Lernphase?",
      options: [
        {emoji:"☀️", text:"Ich erstelle zuerst einen detaillierten Lernplan", type:"P"},
        {emoji:"🌙", text:"Ich fange direkt an und schaue was kommt", type:"K"},
        {emoji:"🦉", text:"Ich lese erstmal den Überblick um alles zu verstehen", type:"T"},
        {emoji:"🌸", text:"Ich mache mir eine bunte Übersicht oder MindMap", type:"V"}
      ]
    },
    {
      text: "Was ist dein größtes Problem beim Lernen?",
      options: [
        {emoji:"☀️", text:"Ich verliere den Überblick wenn ich keinen Plan habe", type:"P"},
        {emoji:"🌙", text:"Ich prokrastiniere bis der Druck groß genug ist", type:"K"},
        {emoji:"🦉", text:"Ich will alles verstehen und komme nicht voran", type:"T"},
        {emoji:"🌸", text:"Trockene Texte ohne Struktur langweilen mich", type:"V"}
      ]
    },
    {
      text: "Wie sehen deine Notizen aus?",
      options: [
        {emoji:"☀️", text:"Sauber gegliedert mit Überschriften und Bullet Points", type:"P"},
        {emoji:"🌙", text:"Schnell hingeworfen, oft chaotisch", type:"K"},
        {emoji:"🦉", text:"Ausführliche Erklärungen in eigenen Worten", type:"T"},
        {emoji:"🌸", text:"Bunt, mit Farben, Pfeilen und Zeichnungen", type:"V"}
      ]
    },
    {
      text: "Was motiviert dich beim Lernen am meisten?",
      options: [
        {emoji:"☀️", text:"Wenn ich Punkte auf meiner To-Do-Liste abhaken kann", type:"P"},
        {emoji:"🌙", text:"Der Adrenalin-Kick kurz vor der Prüfung", type:"K"},
        {emoji:"🦉", text:"Wenn ich ein Konzept wirklich durchdrungen habe", type:"T"},
        {emoji:"🌸", text:"Wenn meine Zusammenfassung schön und übersichtlich ist", type:"V"}
      ]
    },
    {
      text: "Was machst du wenn du beim Lernen feststeckst?",
      options: [
        {emoji:"☀️", text:"Ich plane eine extra Session dafür ein", type:"P"},
        {emoji:"🌙", text:"Ich überspringe es und komme später drauf zurück", type:"K"},
        {emoji:"🦉", text:"Ich recherchiere so lange bis ich es wirklich verstehe", type:"T"},
        {emoji:"🌸", text:"Ich versuche es zu zeichnen oder zu visualisieren", type:"V"}
      ]
    },
    {
      text: "Wie bereitest du dich auf eine Prüfung vor?",
      options: [
        {emoji:"☀️", text:"Mit einem detaillierten Lernplan über mehrere Wochen", type:"P"},
        {emoji:"🌙", text:"Mit intensivem Lernen in den letzten 2-3 Tagen", type:"K"},
        {emoji:"🦉", text:"Durch Wiederholen und Erklären des Stoffs", type:"T"},
        {emoji:"🌸", text:"Mit einer großen bunten Zusammenfassung", type:"V"}
      ]
    },
    {
      text: "Welches Tool nutzt du am liebsten?",
      options: [
        {emoji:"☀️", text:"Kalender, To-Do-App oder Planer", type:"P"},
        {emoji:"🌙", text:"Timer-App oder Pomodoro-Tool", type:"K"},
        {emoji:"🦉", text:"Notion, Obsidian oder ausführliche Notizen", type:"T"},
        {emoji:"🌸", text:"GoodNotes, iPad oder Karteikarten", type:"V"}
      ]
    }
  ];

  const reminders = {
    3: "✨ Fast da – dein Ergebnis wartet!",
    5: "🏁 Nur noch 1 Frage – gleich kommt dein Lernplan!"
  };

  const chartColors = {
    P: "#E8B98A",
    K: "#8FB6DE",
    T: "#B7A488",
    V: "#E39FB0"
  };

  const iconTints = {
    P: "var(--tint-peach)",
    K: "var(--tint-sky)",
    T: "var(--tint-sand)",
    V: "var(--tint-rose)"
  };

  const results = {
    P: {
      emoji:"☀️",
      name:"Aurora – Die Planerin",
      short:"Aurora",
      teaser:"Dein Tag startet mit einem Plan. Struktur ist deine Superkraft.",
      description:"Du liebst Struktur und Kontrolle. Wenn du weißt was wann zu tun ist, läufst du zur Hochform auf. Chaos ist dein größter Feind – ein klarer Plan dein bestes Werkzeug. Wie die Göttin der Morgenröte bringst du Ordnung in jeden neuen Tag, bevor er überhaupt beginnt.",
      method:"Time Blocking",
      hook:"Ein fester Plan macht aus jedem Berg Stoff kleine, machbare Blöcke.",
      steps:[
        {title:"Wochenplan erstellen", sub:"Feste Lernzeiten einplanen – wie Termine, die zählen."},
        {title:"In Etappen denken", sub:"Große Themen in kleine Tagesziele aufteilen."},
        {title:"Haken setzen", sub:"Erledigtes aktiv abhaken – das pusht die Motivation."}
      ],
      products:[
        {image:"apple-pencil.png", name:"Apple Pencil", reason:"Für digitales Planen in GoodNotes.", link:"https://amzn.to/4vSblEk"},
        {image:"ipad.png", name:"iPad", reason:"Dein digitaler Schreibtisch.", link:"https://amzn.to/4xdsjOF"},
        {image:"airpods.png", name:"AirPods", reason:"Für ungestörte Lernblöcke.", link:"https://amzn.to/4c95jrI"},
        {image:"leuchtturm.png", name:"Leuchtturm Notizbuch", reason:"Für analoge Backup-Listen.", link:"https://amzn.to/4fqYunz"}
      ]
    },
    K: {
      emoji:"🌙",
      name:"Luna – Die Nachteule",
      short:"Luna",
      teaser:"Du läufst auf, wenn andere schlafen. Druck ist dein Treibstoff.",
      description:"Du läufst unter Druck zur Hochform auf. Lange Vorbereitungsphasen sind nichts für dich – aber wenn es drauf ankommt, lieferst du ab. Der Trick ist, diesen Fokus früher zu aktivieren. Wie die Mondgöttin entfaltest du deine volle Kraft dann, wenn andere längst aufgegeben haben.",
      method:"Pomodoro + Pareto-Prinzip",
      hook:"Druck ist dein Treibstoff – nutz ihn gezielt, nicht erst in letzter Minute.",
      steps:[
        {title:"25-Minuten-Sprints", sub:"Timer stellen: 25 Min lernen, 5 Min Pause."},
        {title:"Wichtigstes zuerst", sub:"Die 20% des Stoffs finden, die 80% der Punkte bringen."},
        {title:"Eigene Deadline setzen", sub:"Früher als die echte Prüfung – simuliert den Druck."}
      ],
      products:[
        {image:"cube-timer.png", name:"Cube Timer", reason:"Physischer Pomodoro-Timer.", link:"https://amzn.to/4w5dug8"},
        {image:"ipad.png", name:"iPad", reason:"Für schnelle digitale Notizen.", link:"#amazon-link-2"},
        {image:"kaffee-konzentrat.png", name:"Kaffee-Konzentrat", reason:"Für deinen Iced Latte in der Power-Session.", link:"https://amzn.to/4fCa5yX"},
        {image:"airpods.png", name:"AirPods", reason:"Für schnelles Einsteigen.", link:"https://amzn.to/4c95jrI"}
      ]
    },
    T: {
      emoji:"🦉",
      name:"Minerva – Die Denkerin",
      short:"Minerva",
      teaser:"Du analysierst bevor du handelst. Verstehen ist alles.",
      description:"Oberflächliches Lernen ist nichts für dich – du willst wirklich verstehen. Das macht dich zur Expertin, aber manchmal auch zum Zeitfresser. Die Feynman-Technik wurde für dich erfunden. Wie die Göttin der Weisheit gräbst du so lange, bis du den Kern der Sache gefunden hast.",
      method:"Feynman-Technik",
      hook:"Was du nicht einfach erklären kannst, hast du noch nicht wirklich verstanden.",
      steps:[
        {title:"Laut erklären", sub:"In deinen eigenen Worten, als würdest du es unterrichten."},
        {title:"Zusammenfassen", sub:"Ohne Original – so siehst du sofort deine Lücken."},
        {title:"Selbst abfragen", sub:"Bevor der Prof es tut – teste dich selbst zuerst."}
      ],
      products:[
        {image:"leuchtturm.png", name:"Leuchtturm Notizbuch", reason:"Für ausführliche Notizen.", link:"https://amzn.to/4fqYunz"},
        {image:"gelstifte.png", name:"Gelstifte", reason:"Für flüssiges Schreiben beim Denken.", link:"https://amzn.to/4vU4IBm"},
        {image:"karteikartenbox.png", name:"Karteikartenbox", reason:"Zum Selbsttest, ob du den Stoff wirklich verstanden hast.", link:"https://amzn.to/4h2jqme"},
        {image:"airpods.png", name:"AirPods", reason:"Für tiefes Fokussieren.", link:"https://amzn.to/4c95jrI"}
      ]
    },
    V: {
      emoji:"🌸",
      name:"Flora – Die Ästhetin",
      short:"Flora",
      teaser:"Dein Gehirn denkt in Farben. Schönheit und Lernen sind eins.",
      description:"Du denkst in Bildern. Trockene Textwände sind dein Albtraum – eine bunte übersichtliche Zusammenfassung dein Paradies. Wenn du Stoff siehst statt nur liest, bleibt er hängen. Wie die Göttin der Blüten verwandelst du jeden Lernstoff in etwas, das man gerne ansieht.",
      method:"Sketchnotes + Farbsystem",
      hook:"Was du siehst, bleibt hängen – mach deinen Stoff bunt und bildlich.",
      steps:[
        {title:"Farbcode anlegen", sub:"Jedes Fach bekommt seine eigene Farbe."},
        {title:"MindMaps zeichnen", sub:"Komplexe Themen visuell verknüpfen."},
        {title:"Digital sketchen", sub:"GoodNotes nutzen – jederzeit editierbar."}
      ],
      products:[
        {image:"macbook-blue.png", name:"MacBook Air 2026", reason:"Deine digitale Leinwand für Sketchnotes.", link:"#amazon-link-1"},
        {image:"ipad.png", name:"iPad", reason:"Deine digitale Leinwand.", link:"#amazon-link-2"},
        {image:"Pastellmarker.png", name:"Pastell Marker", reason:"Für analoge Notizen.", link:"https://amzn.to/4hzhAt1"},
        {image:"dotted-notizbuch.png", name:"Dotted Notizbuch", reason:"Perfekt für Sketchnotes.", link:"https://amzn.to/4bkH3m9"}
      ]
    }
  };

  /* ---------------- State ---------------- */

  let currentQuestion = 0;
  let selectedType = null;
  const scores = {P:0, K:0, T:0, V:0};
  const answers = new Array(questions.length).fill(null);

  /* ---------------- Elemente ---------------- */

  const screenStart = document.getElementById("lq-screen-start");
  const screenQuiz = document.getElementById("lq-screen-quiz");
  const screenResult = document.getElementById("lq-screen-result");
  const screenConfirm = document.getElementById("lq-screen-confirm");

  const startBtn = document.getElementById("lq-start-btn");
  const nextBtn = document.getElementById("lq-next-btn");
  const progressFill = document.getElementById("lq-progress-fill");
  const quizCounter = document.getElementById("lq-quiz-counter");
  const quizReminder = document.getElementById("lq-quiz-reminder");
  const quizContent = document.getElementById("lq-quiz-content");
  const questionText = document.getElementById("lq-question-text");
  const optionsContainer = document.getElementById("lq-options-container");

  function showScreen(el){
    [screenStart, screenQuiz, screenResult, screenConfirm].forEach(s => s.classList.remove("active"));
    el.classList.add("active");
    window.scrollTo(0,0);
  }

  /* ---------------- Screen 1 -> 2 ---------------- */

  startBtn.addEventListener("click", function(){
    showScreen(screenQuiz);
    renderQuestion();
  });

  /* ---------------- Quiz Logik ---------------- */

  function renderQuestion(){
    const q = questions[currentQuestion];
    progressFill.style.width = ((currentQuestion+1)/questions.length*100) + "%";
    quizCounter.textContent = "Frage " + (currentQuestion+1) + "/" + questions.length;
    quizReminder.textContent = reminders[currentQuestion] || "";

    questionText.textContent = q.text;
    optionsContainer.innerHTML = "";

    q.options.forEach(function(opt){
      const card = document.createElement("div");
      card.className = "option-card";
      card.innerHTML = '<span class="emoji type-' + opt.type + '">' + opt.emoji + '</span><span class="opt-text">' + opt.text + '</span>';
      card.addEventListener("click", function(){ selectOption(card, opt.type); });
      optionsContainer.appendChild(card);
    });

    nextBtn.disabled = answers[currentQuestion] === null;
    if(answers[currentQuestion] !== null){
      const idx = q.options.findIndex(o => o.type === answers[currentQuestion]);
      if(idx > -1) optionsContainer.children[idx].classList.add("selected");
    }
  }

  function selectOption(cardEl, type){
    Array.from(optionsContainer.children).forEach(c => c.classList.remove("selected"));
    cardEl.classList.add("selected");

    if(answers[currentQuestion] !== null){
      scores[answers[currentQuestion]] -= 2;
    }
    answers[currentQuestion] = type;
    scores[type] += 2;

    nextBtn.disabled = false;
  }

  nextBtn.addEventListener("click", function(){
    if(answers[currentQuestion] === null) return;

    quizContent.classList.add("fade-out");
    setTimeout(function(){
      if(currentQuestion < questions.length - 1){
        currentQuestion++;
        renderQuestion();
        quizContent.classList.remove("fade-out");
        quizContent.classList.add("fade-in");
      } else {
        showResult();
      }
    }, 200);
  });

  /* ---------------- Ergebnis ---------------- */

  function calculateWinningType(){
    const order = ["P","K","T","V"];
    let winner = order[0];
    order.forEach(function(type){
      if(scores[type] > scores[winner]) winner = type;
    });
    return winner;
  }

  function showResult(){
    selectedType = calculateWinningType();
    const data = results[selectedType];
    const totalPoints = questions.length * 2;

    document.getElementById("lq-result-emoji").textContent = data.emoji;
    document.getElementById("lq-result-type-name").textContent = data.name;
    document.getElementById("lq-result-teaser").textContent = data.teaser;
    document.getElementById("lq-desc-watermark").textContent = data.emoji;
    document.getElementById("lq-result-description").textContent = data.description;
    const methodNameEl = document.getElementById("lq-method-name");
    methodNameEl.innerHTML = '<span class="method-icon">' + data.emoji + '</span> ' + data.method;
    methodNameEl.style.setProperty("--badge-color", chartColors[selectedType]);
    document.getElementById("lq-method-hook").textContent = data.hook;

    const stepsContainer = document.getElementById("lq-steps-container");
    stepsContainer.innerHTML = "";
    data.steps.forEach(function(step, index){
      const stepEl = document.createElement("div");
      stepEl.className = "step";
      stepEl.innerHTML =
        '<div class="step-line"></div>' +
        '<div class="step-num" style="background:' + chartColors[selectedType] + ';--glow:' + chartColors[selectedType] + '">' + (index + 1) + '</div>' +
        '<div class="step-body">' +
          '<div class="step-title">' + step.title + '</div>' +
          '<div class="step-sub">' + step.sub + '</div>' +
        '</div>';
      stepsContainer.appendChild(stepEl);
    });

    document.getElementById("lq-kit-intro").textContent = "Das nutzen " + data.short + "-Typen am liebsten:";

    const productsContainer = document.getElementById("lq-products-container");
    productsContainer.innerHTML = "";
    data.products.forEach(function(p){
      const card = document.createElement("div");
      card.className = "product-card";
      const visual = p.image
        ? '<img src="' + p.image + '" alt="" class="product-image-float">'
        : '<span class="emoji" style="background:' + iconTints[selectedType] + '">' + p.emoji + '</span>';
      card.innerHTML =
        visual +
        '<div class="product-body">' +
          '<div class="product-name">' + p.name + '</div>' +
          '<div class="product-reason">' + p.reason + '</div>' +
        '</div>' +
        '<a href="' + p.link + '" target="_blank" rel="noopener nofollow sponsored" class="product-cta"><img src="cart-icon.png" alt="">Kaufen</a>';
      productsContainer.appendChild(card);
    });

    const chart = document.getElementById("lq-result-chart");
    chart.innerHTML = "";
    const order = ["P","K","T","V"];
    const labels = {P:"☀️ Aurora", K:"🌙 Luna", T:"🦉 Minerva", V:"🌸 Flora"};

    const winnerPct = Math.round((scores[selectedType] / totalPoints) * 100);
    const winner = document.createElement("div");
    winner.className = "chart-winner";
    winner.style.setProperty("--winner-color", chartColors[selectedType]);
    winner.innerHTML =
      '<div class="chart-winner-top">' +
        '<span class="chart-winner-label">' + labels[selectedType] + '</span>' +
        '<span class="chart-winner-badge">Dein Typ</span>' +
      '</div>' +
      '<div class="chart-winner-pct">' + winnerPct + '%</div>' +
      '<div class="chart-winner-track"><div class="chart-winner-fill"></div></div>';
    chart.appendChild(winner);

    setTimeout(function(){
      winner.querySelector(".chart-winner-fill").style.width = winnerPct + "%";
    }, 100);

    const others = document.createElement("div");
    others.className = "chart-others";
    order.filter(function(type){ return type !== selectedType; }).forEach(function(type){
      const pct = Math.round((scores[type] / totalPoints) * 100);
      const item = document.createElement("span");
      item.className = "chart-other-item";
      item.innerHTML = labels[type] + ' <b>' + pct + '%</b>';
      others.appendChild(item);
    });
    chart.appendChild(others);

    ["lq-bubble-1", "lq-bubble-2", "lq-bubble-3", "lq-bubble-4"].forEach(function(id, i){
      const bubble = document.getElementById(id);
      bubble.classList.remove("show");
      void bubble.offsetWidth;
      bubble.style.animationDelay = (i * 0.5) + "s";
      bubble.classList.add("show");
    });

    showScreen(screenResult);
  }

  /* ---------------- Email Formular -> Klaviyo ---------------- */

  const KLAVIYO_COMPANY_ID = "YmhTku";
  const KLAVIYO_LIST_ID = "VyPppZ"; // Liste: "Klausur Notfall Kit Freebie"

  const emailForm = document.getElementById("lq-email-form");
  const emailInput = document.getElementById("lq-email-input");
  const firstNameInput = document.getElementById("lq-firstname-input");
  const emailBtn = emailForm.querySelector(".freebie-btn");
  const emailBtnLabel = emailBtn.textContent;

  emailForm.addEventListener("submit", async function(e){
    e.preventDefault();
    const email = emailInput.value.trim();
    const firstName = firstNameInput.value.trim();
    if (!email) return;

    emailBtn.disabled = true;
    emailBtn.textContent = "Einen Moment …";

    const profileAttributes = {
      email: email
    };
    if (firstName) {
      profileAttributes.first_name = firstName;
    }

    try {
      const res = await fetch(
        "https://a.klaviyo.com/client/subscriptions/?company_id=" + KLAVIYO_COMPANY_ID,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "revision": "2024-10-15"
          },
          body: JSON.stringify({
            data: {
              type: "subscription",
              attributes: {
                profile: {
                  data: {
                    type: "profile",
                    attributes: profileAttributes
                  }
                }
              },
              relationships: {
                list: {
                  data: { type: "list", id: KLAVIYO_LIST_ID }
                }
              }
            }
          })
        }
      );

      if (!res.ok && res.status !== 202) {
        throw new Error("Klaviyo request failed: " + res.status);
      }

      const persona = results[selectedType];
      fetch(
        "https://a.klaviyo.com/client/events/?company_id=" + KLAVIYO_COMPANY_ID,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "revision": "2024-10-15"
          },
          body: JSON.stringify({
            data: {
              type: "event",
              attributes: {
                properties: {
                  Lerntyp: persona ? persona.short : null,
                  Lernmethode: persona ? persona.method : null
                },
                metric: {
                  data: {
                    type: "metric",
                    attributes: { name: "Lerntyp Quiz - Vorlage angefordert" }
                  }
                },
                profile: {
                  data: {
                    type: "profile",
                    attributes: { email: email }
                  }
                }
              }
            }
          })
        }
      ).catch(function(err){ console.error("Klaviyo event error:", err); });

      showScreen(screenConfirm);
    } catch (err) {
      console.error("Klaviyo subscribe error:", err);
      emailBtn.disabled = false;
      emailBtn.textContent = emailBtnLabel;
      alert("Da ist leider etwas schiefgelaufen. Bitte versuch's gleich nochmal.");
    }
  });

  /* ---------------- Share Button ---------------- */

  document.getElementById("lq-share-btn").addEventListener("click", async function(){
    const data = results[selectedType];
    const shareData = {
      title: "Welcher Lerntyp bist du?",
      text: "Ich bin " + data.emoji + " " + data.name + "! Finde deinen Lerntyp heraus:",
      url: window.location.href
    };
    if(navigator.share){
      try{ await navigator.share(shareData); }catch(err){ /* abgebrochen */ }
    } else {
      try{
        await navigator.clipboard.writeText(shareData.text + " " + shareData.url);
        alert("Link kopiert! Teile ihn mit deiner Freundin 🎉");
      }catch(err){
        alert(shareData.text + " " + shareData.url);
      }
    }
  });

})();